var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme'; // import { 
//   classNames, 
//   entityLangPath, 
//   GlobeCircleIcon, 
//   Icons 
// } from '@shapeable/web';

import { classNames } from '../../utils/cn';
import { ShareMenuItem } from './share-menu-item';
var cls = classNames('share-menu');
export var ShareMenuDefaultProps = {
  items: ['copy-site', 'copy-page', 'facebook', 'twitter', 'linkedin', 'email']
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(ShareMenuItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
/* @ts-ignore */

export var ShareMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
      items = props.items,
      onItemClick = props.onItemClick;
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, items.map(function (type) {
    return React.createElement(My.Item, {
      onClick: onItemClick,
      type: type,
      isInverted: true,
      key: type
    });
  }));
});
ShareMenu.cls = cls;
ShareMenu.defaultProps = ShareMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;